export default __webpack_public_path__ + "static/media/955.6e337239.png";